import { intl } from "LocaleWrapper";

export enum InvoiceGroupStatus {
	Ready = "READY",
	ManualActionRequired = "MANUAL_ACTION_REQUIRED",
	NotReady = "NOT_READY"
}

const invoiceGroupStatusConfig: Record<InvoiceGroupStatus, { label: string; color: string }> = {
	[InvoiceGroupStatus.NotReady]: { label: intl.formatMessage({ id: "NOT_READY" }), color: "#999999" },
	[InvoiceGroupStatus.ManualActionRequired]: { label: intl.formatMessage({ id: "MANUAL_ACTION_REQUIRED" }), color: "#D89521" },
	[InvoiceGroupStatus.Ready]: { label: intl.formatMessage({ id: "READY_TO_DECLARE" }), color: "#45B741" },
};

export const getInvoiceGroupStatusConfig = (agreement: { ready: boolean; manualActionRequired: boolean }) => {
	const status = agreement.manualActionRequired ? (
		InvoiceGroupStatus.ManualActionRequired
	) : agreement.ready ? (
		InvoiceGroupStatus.Ready
	) : (
		InvoiceGroupStatus.NotReady
	);

	return invoiceGroupStatusConfig[status];
};
